/* eslint-disable no-magic-numbers */
export enum FileType {
  Image = 1,
  Video = 2,
  Gif = 3,
  Spreadsheet = 4
}
